// Embed Code (blockgrid/Components/embedCode.cshtml): an iframe filling the width keeps the shape
// its width and height attributes give it (e.g. a 560 x 315 video), instead of a fixed height.

export function initEmbeds(): void {
  document.querySelectorAll<HTMLIFrameElement>('[data-embed] iframe[width][height]').forEach((frame) => {
    const width = parseFloat(frame.getAttribute('width') ?? '');
    const height = parseFloat(frame.getAttribute('height') ?? '');
    if (width > 0 && height > 0 && !frame.getAttribute('width')!.includes('%')) {
      frame.style.aspectRatio = `${width} / ${height}`;
      frame.style.height = 'auto';
    }
  });
}
